import Stats from 'stats.js';
import { MATE_STATS } from '@/enums';

export const initStats = (container: HTMLElement) => {
  if (
    window.location.href.includes('__stats__=1') ||
    localStorage.getItem(MATE_STATS) == '1'
  ) {
    let stats = new Stats();
    stats.showPanel(2);
    stats.dom.style.left = `${window.document.body.clientWidth - 80}px`;
    // stats.dom.style.right = '0px';
    stats.dom.setAttribute('draggable', true);
    const img = new Image();
    img.src =
      'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
    const dragHandler = (event: DragEvent) => {
      event.preventDefault();
      if (!event.x && !event.y) {
        return;
      }
      stats.dom.style.left = `${event.x - 40}px`;
      stats.dom.style.top = `${event.y - 24}px`;
    };
    // stats.dom.addEventListener('drag', dragHandler);
    stats.dom.addEventListener('dragstart', (event: DragEventInit) => {
      if (!event.dataTransfer) {
        return;
      }
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setDragImage(img, 0, 0);
    });
    stats.dom.addEventListener('drag', dragHandler);
    // stats.dom.addEventListener('dragend', dragHandler);
    container.appendChild(stats.dom);

    function animate() {
      stats.update();
      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }
};
